import React from "react";

interface SignalBarsProps {
  value: number; // 1-5
  max?: number;
  className?: string;
}

/**
 * Renderiza barras de señal tipo móvil (de 1 a 5)
 */
export const SignalBars: React.FC<SignalBarsProps> = ({ value, max = 5, className = "" }) => {
  // Asegura que value esté entre 0 y max
  const safeValue = Math.max(0, Math.min(max, value ?? 0));
  return (
    <div className={`flex items-end gap-[2px] h-5 ${className}`} title={`Nivel: ${safeValue}/${max}`}>
      {Array.from({ length: max }).map((_, i) => (
        <div
          key={i}
          className={`w-1 rounded-sm transition-colors duration-200 ${
            i < safeValue ? "bg-green-500" : "bg-gray-300"
          }`}
          style={{ height: `${6 + i * 5}px` }}
        />
      ))}
    </div>
  );
};

export default SignalBars;
